module.exports = __webpack_public_path__ + "static/spaceKitchenMobile@x2-0437a446d2be37999d965d6fc5b25a3e.png";